// src/pages/AboutPage.jsx
import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import "./AboutPage.css";

export default function AboutPage() {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "kz");

  // 🔒 отключаем прокрутку только на этой странице
  useEffect(() => {
    document.body.classList.add("no-scroll-about");
    return () => document.body.classList.remove("no-scroll-about");
  }, []);

  const t = {
    kz: {
      title: "Жоба туралы",
      blockTitle: "Ғылыми-педагогикалық сараптама",
      doc: "Қазақстан Республикасы Білім және ғылым министрінің 2012 жылғы 24 шілдедегі № 344 бұйрығы",
      docHref: "https://adilet.zan.kz/kaz/docs/V1200007876",
    },
    ru: {
      title: "О проекте",
      blockTitle: "Научно-педагогическая экспертиза",
      doc: "Приказ Министра образования и науки Республики Казахстан от 24 июля 2012 года № 344",
      docHref: "https://adilet.zan.kz/rus/docs/V1200007876",
    },
  }[locale];

  return (
    <div className="about-page">
      {/* правый анимированный орнамент как на главной */}
      <div className="about-ornament glow sparkles" aria-hidden="true">
        <div className="orn-img a" style={{ backgroundImage: "url(/img/ornament.svg)" }} />
        <div className="orn-img b" style={{ backgroundImage: "url(/img/ornament.svg)" }} />
        <div className="orn-img c" style={{ backgroundImage: "url(/img/ornament.svg)" }} />
      </div>

      {/* единая обёртка для хедера */}
      <div className="container header-wrap">
        <Header locale={locale} setLocale={setLocale} />
      </div>

      <main className="container about-wrapper">
        <section className="about-card glass">
          <h2 className="section-title">{t.blockTitle}</h2>

          {locale === "kz" ? (
            <div className="about-text">
              <p>Республикалық ғылыми-практикалық білім мазмұнын сараптау орталығының (бұдан әрі – BMSO)
                қызметі оқу сапасын арттыруға бағытталып, білім беру ресурстарын жан-жақты және объективті
                бағалау арқылы жүзеге асады. BMSO-ның басты мақсаты – білім беру мазмұнының сапасын ғылыми
                және педагогикалық сараптама жүргізу арқылы арттыру.</p>
              <p className="strong">Ғылыми-педагогикалық сараптама – бұл оқу басылымдарының келесі талаптарға сәйкестігін
                қамтамасыз ету мақсатында жүргізілетін кешенді кәсіби бағалау:</p>
              <ul>
                <li>қазіргі заманғы ғылыми білім мен жетістіктерге;</li>
                <li>мемлекеттік жалпыға міндетті білім беру стандарттарының талаптарына;</li>
                <li>педагогикалық мақсатқа сәйкестігі, қолжетімділігі және қисындылық принциптеріне;</li>
                <li>білім алушылардың жас ерекшеліктері мен психологиялық ерекшеліктеріне.</li>
              </ul>
              <p>BMSO жоғары білікті сарапшылар – ғалымдардың, әдіскерлердің, тәжірибелі педагогтердің жұмысын
                ұйымдастырады. Бұл мамандар оқу басылымдарының мазмұнын талдап, олқылықтарды анықтайды, сапаны
                жақсарту бойынша ұсыныстар береді және сараптамалық қорытынды дайындайды.</p>
              <p>BMSO қорытындылары Қазақстан Республикасының білім беру ұйымдарында оқу басылымдарын пайдалануға
                рұқсат беру туралы шешім қабылдауға негіз болады.</p>
              <p className="strong">BMSO қызметінің басты мақсаты – білім беру мазмұнының сапасын арттыруға және заманауи, ғылыми
                негізделген әрі әдістемелік тұрғыдан дәлелді оқу үдерісін қамтамасыз етуге ықпал ету.</p>
            </div>
          ) : (
            <div className="about-text">
              <p>Деятельность Республиканского научно-практического центра экспертизы содержания образования
                (далее – BMSO) направлена на повышение качества обучения путём всесторонней и объективной
                оценки образовательных ресурсов. Цель деятельности BMSO – повышение качества содержания
                образования путём проведения научной и педагогической экспертизы.</p>
              <p className="strong">Научно-педагогическая экспертиза – это комплексная профессиональная оценка учебных изданий с
                целью обеспечения их соответствия:</p>
              <ul>
                <li>современным научным знаниям и достижениям;</li>
                <li>требованиям государственных общеобязательных стандартов образования;</li>
                <li>принципам педагогической целесообразности, доступности и логичности;</li>
                <li>возрастным и психологическим особенностям обучающихся.</li>
              </ul>
              <p>BMSO организует работу высококвалифицированных экспертов – учёных, методистов, педагогов-практиков,
                которые анализируют содержание учебных изданий, выявляют недочёты, дают рекомендации по улучшению
                качества и готовят экспертное заключение.</p>
              <p>Заключения BMSO являются основанием для принятия решений о допуске учебных изданий к использованию
                в образовательных организациях Республики Казахстан.</p>
              <p className="strong">Главная цель деятельности BMSO – содействие повышению качества содержания образования и обеспечению
                современного, научно обоснованного и методически выверенного учебного процесса.</p>
            </div>
          )}

          <p className="doc-link-wrap">
            <a className="doc-link pill" href={t.docHref} target="_blank" rel="noopener noreferrer">
              📄 {t.doc}
            </a>
          </p>

          <div className="brand-name">BMSO</div>
        </section>
      </main>
    </div>
  );
}
